export default __webpack_public_path__ + "static/paperplane-081a16c961528cf00ac5308a68f7f5f1.png";